import { useLocation, Link } from 'react-router-dom'

export default function Summary() {
    const location = useLocation()
    const score = location?.state?.score?.correct ?? 0
    const total = location?.state?.total ?? 0
    const percent = total > 0 ? Math.round((score / total) * 100) : 0

    return (

<div
      className="bg-notation-wrapper view"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL + '/img/bg-yellow.svg'})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom left',
        minHeight: '100vh',
        width: '100%',
      }}
    >
      <main className="container" role="main">

        <Link to="/" className="back-btn">← Zurück</Link>
        <h1 className="section-title">Grafische Notation lesen und schreiben</h1>
      </main>


      <div className="slider-wrapper">
        <div className="slider-container">
          <div className="slider">


            <section className="card">
                <h1>Auswertung</h1>
                <p>
                    Du hast <strong>{score}</strong> von <strong>{total}</strong> Fragen korrekt beantwortet
                    — das sind <strong>{percent}%</strong>.
                </p>
                <Link className="btn" to="/">Zur Startseite</Link>
            </section>


          </div>

        </div>
      </div>

    </ div >
    )
}
